export function mapStylesFactory(params: any) {
    return [
        { elementType: 'geometry', stylers: [{ color: '#f5f0eb' }] },
        {
            featureType: 'poi.attraction',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'poi.business',
            elementType: 'labels',
            stylers: [
                { color: '#c6d1d7' },
                { visibility: params.showBussiness ? 'on' : 'off' },
            ]
        },
        {
            featureType: 'poi.business',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#7e8ea5' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.business',
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#ffffff' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.park',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [{ color: '#c7edd5' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#239b4f' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#ffffff' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.school',
            elementType: 'labels',
            stylers: [
                { color: '#c6d1d7' },
                { visibility: 'on' }
            ]
        },
        {
            featureType: 'poi.school',
            elementType: 'geometry.fill',
            stylers: [{ color: '#deecef' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.school',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#7e8ea5' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.school',
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#ffffff' }, { visibility: 'on' }]
        },
        {
            featureType: 'poi.government',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'poi.medical',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'poi.place_of_worship',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'poi.sports_complex',
            elementType: 'labels',
            stylers: [
                { visibility: 'off' }
            ]
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
                { 'visibility': 'on' },
                { color: '#ffffff' }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#9ca5b3' }]
        },
        {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#e3e3e3' }]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [{ color: '#ffffff' }]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{ color: '#babebf' }]
        },
        {
            featureType: 'road.highway',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#f7f7f7' }]
        },
        {
            featureType: 'road.highway',
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#f7f7f7' }, { 'visibility': 'off' }]
        },
        {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{ color: '#b1dce0' }]
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#249aa0' }]
        },
        {
            featureType: 'water',
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#34c1c9' }]
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [{ color: '#d5dbcb' }]
        },
        {
            featureType: 'transit.station',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#d59563' }]
        },
    ];
}
